// Sidebar links open a list fresh: they navigate with state { freshList: <unique number> }. That state stays on the
// browser history entry, so coming back to it later (browser Back / Forward) must not count as fresh again: once
// the page that was opened fresh is left, its number is marked as used (kept for this browser tab).

const USED_KEY = "pb.freshListUsed";

const readUsed = (): number[] => {
    try {
        return JSON.parse(sessionStorage.getItem(USED_KEY) || "[]");
    } catch {
        return [];
    }
};

// The visit came from a sidebar click and is being opened for the first time.
export const isFreshListVisit = (state: any): boolean => {
    const freshList = state?.freshList;
    return !!freshList && !readUsed().includes(freshList);
};

// The page opened from that sidebar click is being left: later visits to the same history entry are returns.
export const markFreshListVisitUsed = (state: any) => {
    const freshList = state?.freshList;
    if (!freshList) return;
    try {
        const used = readUsed();
        if (!used.includes(freshList)) sessionStorage.setItem(USED_KEY, JSON.stringify([...used, freshList].slice(-50)));
    } catch {
        // Storage unavailable: a Back to it would then open fresh.
    }
};

// A sidebar click starts the whole flow over: every list's remembered place and clicked row in this browser tab is
// forgotten (not only the list that was clicked), so deeper lists (e.g. an auction's lots) open fresh too.
export const forgetRememberedLists = () => {
    try {
        Object.keys(sessionStorage)
            .filter(key => key.startsWith("pb.list:") || key.startsWith("pb.listRow:"))
            .forEach(key => sessionStorage.removeItem(key));
    } catch {
        // Storage unavailable: nothing is remembered anyway.
    }
};
